import React, { useEffect, useState, createRef } from 'react';
import { Box } from 'reflexbox'
import Modal from '@mui/material/Modal';
import { X } from 'lucide-react';
import "./styles.css";
import { useQuery, useLazyQuery, useMutation } from '@apollo/react-hooks'
import { clientsMutations } from '../../../graphql/mutations'
import { clientsQueries } from '../../../graphql/queries'
import { AccountUser } from '../../../models'
import { AccountUserSchema } from '../../../validate'
import useAlertStack from 'ui-components/lib/hooks/useAlertStack'
import InputMask from 'react-input-mask'
import { useFormik } from 'formik'
import graphqlHelpers from 'ui-components/lib/helpers/graphql'
import Spinner from 'ui-components/lib/components/Spinner'
import TextField from 'ui-components/lib/components/TextField'
import Select from 'ui-components/lib/components/Select'
import LittleInfoBalloon from '../../LittleInfoBallon'
// import Coruja from "../../../assets/img/owl/seeingSomeFiles.svg"

const AccountUserModal = (props) => {
    const {
        handleClose,
        openModal,
        userType,
        userId
    } = props;

  const { showMessage } = useAlertStack()

  const [cpfMask, setCpfMask] = useState("999.999.999-99")
  const [accountTypes, setAccountTypes] = useState('')

  const { data: dataAccountTypes } = useQuery(clientsQueries.GET_ACCOUNT_TYPES)

  const [getAccountUser, { data: dataAccountUser }] = useLazyQuery(clientsQueries.GET_ACCOUNT_USER)

  const [createAccountUser, { loading: loadingCreateAccountUser }] = useMutation(clientsMutations.CREATE_ACCOUNT_USER, {
    onCompleted() {
      showMessage({
        title: 'Cadastrado realizado com sucesso',
        message: 'Seu cadastro foi atualizado.',
        color: 'success',
        position: 'bottom-left',
        time: 4000,
      })
      handleClose()
    },
    update: graphqlHelpers.deleteItemsFromCache('Client'),
    onError(error) {
      const customError = ((((((error.graphQLErrors || [])[0] || {}).extensions || {}).response || {}).body || {}).message || {}).errors

      showMessage({
        title: 'Cadastro não atualizado',
        message: customError || 'Ocorreu algum erro desconhecido',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
      handleClose()
    },
  })

  const [updateAccountUser, { loading: loadingUpdateAccountUser }] = useMutation(clientsMutations.UPDATE_ACCOUNT_USER, {
    onCompleted() {
      showMessage({
        title: 'Cadastrado atualizado com sucesso',
        message: 'Seu cadastro foi atualizado.',
        color: 'success',
        position: 'bottom-left',
        time: 4000,
      })
      handleClose()
    },
    update: graphqlHelpers.deleteItemsFromCache('Client'),
    onError(error) {
      const customError = ((((((error.graphQLErrors || [])[0] || {}).extensions || {}).response || {}).body || {}).message || {}).errors

      showMessage({
        title: 'Cadastro não atualizado',
        message: customError || 'Ocorreu algum erro desconhecido',
        color: 'danger',
        position: 'bottom-left',
        time: 4000,
      })
      handleClose()
    },
  })

  const formRefAccountUser = createRef()

  const formikAccountUser = useFormik({
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: new AccountUser(),
    validationSchema: AccountUserSchema,
    onSubmit: (values) => {
      if(userId){
        updateAccountUser({ 
          variables: values 
        })
      } else {
        createAccountUser({ 
          variables: values 
        })
      }
    },
  })

  const handleChangeCpfMask = (event) => {
    if(event.key === "Backspace"){
      setCpfMask("99999999999")
    } else {
      setCpfMask("999.999.999-99")
    }
  }

  const handleSubmitAccountUser = (event) => {
    event.preventDefault()

    // eslint-disable-next-line no-unused-expressions
    formRefAccountUser.current?.reportValidity?.() // manually trigger html validation through ref

    formikAccountUser.handleSubmit()
  }

  useEffect(() => {
    if (userId){
      getAccountUser({ variables: { id: userId } })
    }
  }, [userId]) //eslint-disable-line

  useEffect(() => {
    if (dataAccountTypes){
      setAccountTypes(dataAccountTypes.getAccountTypes.filter(reg => reg.type === 'Administrador' || reg.type === 'Secundário'))
    }
  }, [dataAccountTypes]) //eslint-disable-line

  useEffect(() => {
    if (dataAccountUser && dataAccountTypes){
      const filteredSelectedPackage = dataAccountTypes.getAccountTypes.filter((typeItem, typeIndex, array) => {
        return typeItem._id === dataAccountUser.getAccountUser.accountTypeId
      })

      formikAccountUser.setValues({
        ...formikAccountUser.values,
        id: dataAccountUser.getAccountUser._id,
        name: dataAccountUser.getAccountUser.name,
        email: dataAccountUser.getAccountUser.email,
        document: dataAccountUser.getAccountUser.document,
        accountType: filteredSelectedPackage[0].type,
        accountTypeId: dataAccountUser.getAccountUser.accountTypeId,
        product: dataAccountUser.getAccountUser.product,
        relatedness: dataAccountUser.getAccountUser.relatedness
      })
    }

  }, [dataAccountUser, dataAccountTypes]) //eslint-disable-line


  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      sx={{
        zIndex: 9999,
        '& .MuiBackdrop-root': {
          backgroundColor: 'var(--overlay-bg)',
          backdropFilter: 'blur(4px)',
        }
      }}
      disableAutoFocus
    >
      <Box className="account-user-modal-wrapper">
        <div className="account-user-modal-header">
          <h2>{userId ? 'Editar' : 'Adicionar'} {userType === 'Dependentes' ? 'dependente' : 'usuário'}</h2>
          <button 
            className="account-user-modal-close-button"
            onClick={handleClose}
            aria-label="Fechar modal"
          >
            <X size={20} />
          </button>
        </div>
        
        <form noValidate onSubmit={handleSubmitAccountUser} ref={formRefAccountUser} style={{width:'100%', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0}}>
          <div style={{flex: 1, overflowY: 'auto', minHeight: 0}}>
            <div className="account-user-modal-form-section">
              <TextField
                id="name"
                name={'name'}
                label={'Nome'}
                placeholder={'Nome completo'}
                value={formikAccountUser.values.name}
                onChange={formikAccountUser.handleChange}
                error={formikAccountUser.errors.name}
                mt={0}
                mb={3}
                onBlur={formikAccountUser.handleBlur}
              />
            </div>

            <div className="account-user-modal-form-section">
              <InputMask
                id="document"
                name={'document'}
                label={'CPF'}
                placeholder={'123.456.789-10'}
                mask={cpfMask} 
                maskChar={null} 
                value={formikAccountUser.values.document} 
                onChange={formikAccountUser.handleChange} 
                onKeyDown={handleChangeCpfMask} 
                onBlur={formikAccountUser.handleBlur}                  
                error={formikAccountUser.errors.document ? true : false}
                helperText={formikAccountUser.errors.document}
                mt={0}
                mb={3}
              >
                {(inputFormProps) => (
                  <TextField 
                    {...inputFormProps}
                  />
                )}
              </InputMask>
            </div>

            <div className="account-user-modal-form-section">
              <TextField
                id="email"
                name={'email'}
                label={'Email'}
                placeholder={'email@exemplo.com'}
                value={formikAccountUser.values.email}
                onChange={formikAccountUser.handleChange}
                error={formikAccountUser.errors.email}
                mt={0}
                mb={3}
                onBlur={formikAccountUser.handleBlur}
              />
            </div>

            <div className="account-user-modal-form-section">
              <TextField       
                id={'password'}
                name={'password'}
                label={'Nova Senha'}
                placeholder={'Mínimo 6 caracteres'}
                value={formikAccountUser.values.password}
                onChange={formikAccountUser.handleChange}
                error={formikAccountUser.errors.password}
                type={'password'}
                mt={0}
                mb={3}
                onBlur={formikAccountUser.handleBlur}
              />
            </div>

            <div className="account-user-modal-form-section">
              <TextField
                id={'passwordConfirmation'}
                name={'passwordConfirmation'}
                label={'Confirmar nova senha'}
                placeholder={'Digite a senha novamente'}
                value={formikAccountUser.values.passwordConfirmation}
                onChange={formikAccountUser.handleChange}
                error={formikAccountUser.errors.passwordConfirmation}
                type={'password'}
                mt={0}
                mb={3}
                onBlur={formikAccountUser.handleBlur}
              />
            </div>

            <div className="account-user-modal-form-section">
              <p className="select-label">Acesso</p>
              <Select
                id={'product'}
                name={'product'}
                value={formikAccountUser.values.product} 
                onChange={formikAccountUser.handleChange} 
                style={{lineHeight:'unset', marginTop:'0', width: '100%'}}
              >
                <option key={""} value={""} disabled>Selecionar produto</option>
                <option key="data-privacy" value="data-privacy">Data Privacy</option>
                <option key="bonuz-plans" value="bonuz-plans">Planos B.onuz</option>                  
                <option key="contractual-management" value="contractual-management">Gestão Contratual</option>
              </Select>
            </div>

            {userType === 'Dependentes' ? (
              <div className="account-user-modal-form-section">
                <TextField
                  id="relatedness"
                  name={'relatedness'}
                  label={'Parentesco'}
                  placeholder={'Ex: Mãe, Pai, Filho, Filha'}
                  value={formikAccountUser.values.relatedness}
                  onChange={formikAccountUser.handleChange}
                  error={formikAccountUser.errors.relatedness}
                  mt={0}
                  mb={3}
                  onBlur={formikAccountUser.handleBlur}
                />
              </div>
            ) : null}

            <div className="account-user-modal-form-section">
              <span>Tipo de Perfil</span>
              <div className="account-user-modal-radio-group">
                {(accountTypes || []).map((item, index) => {
                  if (userType === 'Dependentes' && item.type !== 'Dependentes') return null;
                  if (userType !== 'Dependentes' && item.type === 'Dependentes') return null;
                  
                  return (
                    <label key={index} className="account-user-modal-radio-item">
                      <input
                        name="accountTypeId"
                        type="radio" 
                        value={item._id} 
                        checked={formikAccountUser.values.accountTypeId === item._id}
                        onChange={formikAccountUser.handleChange}
                      />
                      <p>{item.type}</p>
                      <div className="info-toggle">
                        <LittleInfoBalloon info={item.description} />
                      </div>
                    </label>
                  );
                })}
              </div>
            </div>

            {formikAccountUser.values.id ? (
              <div className="account-user-modal-hint-text">
                *Para atualizar a senha, preencha os campos com a nova senha.
              </div>
            ) : null}
          </div>

          <div className="account-user-modal-buttons">
            <button
              type={'submit'}
              className="account-user-modal-primary-button"
              disabled={loadingCreateAccountUser || loadingUpdateAccountUser}
            >
              {loadingCreateAccountUser || loadingUpdateAccountUser ? (
                <Spinner />
              ) : (
                formikAccountUser.values.id ? 'Atualizar' : 'Adicionar'
              )}
            </button>
            <button
              type="button"
              onClick={handleClose}
              className="account-user-modal-secondary-button"
            >
              Cancelar
            </button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default AccountUserModal;
